import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import PortalLayout from "../components/PortalLayout";
import AdminSubNav from "../components/AdminSubNav";
import { useAdminAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Mail } from "lucide-react";

function formatDate(iso) {
    try {
        return new Date(iso).toLocaleString(undefined, {
            year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
        });
    } catch { return iso; }
}

export default function AdminContact() {
    const { admin } = useAdminAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const { data } = await api.get("/admin/contact-submissions");
                setItems(data.items || []);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (admin === null) return null;
    if (!admin) return <Navigate to="/login" replace />;

    return (
        <PortalLayout>
            <section className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16 pt-16 pb-32" data-testid="admin-contact-page">
                <div className="mb-10">
                    <span className="font-label text-[11px] text-[#cfa052]">Admin · messages</span>
                    <h1 className="mt-4 font-serif-display text-5xl md:text-6xl tracking-tighter text-[#e8e4db]" data-testid="admin-contact-title">
                        Squad <span className="italic">messages</span>
                    </h1>
                    <p className="mt-4 font-poetic text-[#9a958a] max-w-2xl">
                        Latest first. Members reach out through the Contact form — answer them by email.
                    </p>
                </div>

                <AdminSubNav />

                {loading ? (
                    <div className="text-center py-32 font-poetic text-[#9a958a]" data-testid="admin-contact-loading">opening the mailbag…</div>
                ) : items.length === 0 ? (
                    <div className="text-center py-32" data-testid="admin-contact-empty">
                        <Mail className="w-8 h-8 mx-auto text-[#6e6a62] mb-3" />
                        <p className="font-poetic text-[#9a958a]">Nothing yet. The line is quiet.</p>
                    </div>
                ) : (
                    <ul className="divide-y divide-white/5" data-testid="admin-contact-list">
                        {items.map((m) => (
                            <li key={m.id} className="py-6 grid md:grid-cols-[1fr,3fr,140px] gap-4 md:gap-8" data-testid={`admin-contact-row-${m.id}`}>
                                <div>
                                    <div className="font-serif-display text-xl text-[#e8e4db]">{m.name}</div>
                                    <a href={`mailto:${m.email}`} className="font-label text-[10px] text-[#cfa052] hover:text-[#e0b569] transition-colors break-all">
                                        {m.email}
                                    </a>
                                </div>
                                <div className="font-poetic text-[#9a958a] leading-relaxed whitespace-pre-wrap text-[15px]">
                                    {m.message}
                                </div>
                                <div className="font-label text-[10px] text-[#6e6a62] md:text-right">
                                    {formatDate(m.submittedAt)}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </section>
        </PortalLayout>
    );
}
